// ---------------------------------------------------------------------------
// Registro de miembros de la comunidad (captura de "leads")
//
// Cada persona que inicia sesión / se une queda registrada aquí. Los datos se
// guardan localmente (localStorage) para que NADA se pierda, y quedan listos
// para sincronizarse con un CRM externo (HubSpot, Salesforce, Zapier, etc.).
//
// PARA CONECTAR UN CRM REAL:
//   1. Crea un "webhook" en tu CRM o en Zapier/Make (un endpoint que reciba POST).
//   2. Pega esa URL en CRM_WEBHOOK_URL abajo.
//   Cuando esté configurada, cada registro se enviará automáticamente además
//   de guardarse localmente. Si está vacía, solo se guarda localmente.
// ---------------------------------------------------------------------------

// TODO: pega aquí la URL del webhook de tu CRM (Zapier/HubSpot/Make/etc.)
export const CRM_WEBHOOK_URL = ''

export interface Lead {
  name: string
  email: string
  phone?: string
  lang: string
  source: string
  createdAt: string
}
const STORAGE_KEY = 'communityLeads'

// Devuelve todos los registros guardados localmente.
export function getLeads(): Lead[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? (JSON.parse(raw) as Lead[]) : []
  } catch {
    return []
  }
}

// Guarda un registro localmente y, si hay webhook configurado, lo envía al CRM.
export async function registerLead(
  input: Omit<Lead, 'createdAt'>,
): Promise<Lead> {
  const lead: Lead = { ...input, createdAt: new Date().toISOString() }

  // 1) Persistencia local (siempre, para no perder ningún registro)
  try {
    const leads = getLeads()
    leads.push(lead)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(leads))
  } catch {
    /* localStorage bloqueado — continuamos igual */
  }

  // 2) Envío al CRM externo (solo si hay webhook configurado)
  if (CRM_WEBHOOK_URL) {
    try {
      await fetch(CRM_WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(lead),
      })
    } catch {
      // Si falla el envío, el registro ya quedó guardado localmente y se puede
      // reintentar/sincronizar más tarde. No bloqueamos al usuario.
    }
  }

  return lead
}
